module.exports = "<item *ngFor=\"let item of items\" [item]=item (selectRequest)=\"selectRequest($event)\"></item>\n<new-item *ngIf=\"newItemRef\" [ref]=\"newItemRef\" (selectRequest)=\"selectRequestNew($event)\"></new-item>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/ListForObservable.component.html
// module id = ../../../../../src/app/items/ListForObservable.component.html
// module chunks = main